<ng-container *transloco="let t; read: 'downloads'">
  <div class="p-5">
    <div>
      <drdp-title [title]="title"></drdp-title>
      <div>
        <p>{{ t('ratings.description') }}</p>
      </div>
    </div>
    <drdp-download-search (searchClicked)="downloadDemographics($event)" [is2025Page]="is2025Page"></drdp-download-search>
  </div>
</ng-container>